import React from 'react'
import classnames from 'classnames'
import { Pill } from '@/components/atoms'

export interface DataSetSelectorProps {
    label: string
    color?: string
    isSelected?: boolean
    selectedChildrenCount?: number
    onChange: (isSelected: boolean) => void
}

export const DataSetSelector: React.FC<DataSetSelectorProps> = ({
    label,
    color,
    isSelected,
    selectedChildrenCount,
    onChange,
}) => {
    const wrapperClassname = classnames(
        'flex items-center justify-between rounded-lg border px-3 py-2 text-sm shadow-sm shadow-inset-1',
        {
            'border-azure': isSelected,
            'border-neutral-300': !isSelected,
        }
    )

    return (
        <div
            className={wrapperClassname}
            data-testid={'dataset-selector"'}
            onClick={() => {
                onChange(!isSelected)
            }}
        >
            <div className="flex w-0 flex-grow items-center gap-1">
                <span
                    className="max-w-[calc(100%-32px)] truncate"
                    data-testid={`selector-label-${label}`}
                >
                    {label}
                </span>
                {selectedChildrenCount && (
                    <Pill value={selectedChildrenCount} />
                )}
            </div>

            <span
                className={classnames(
                    'ml-1 h-2 w-2 rounded-full transition-opacity',
                    {
                        'opacity-100': isSelected,
                        'opacity-0': !isSelected,
                    }
                )}
                style={{ backgroundColor: color }}
                data-testid={`colored-circle`}
            ></span>
        </div>
    )
}
